import { Modal, Form, Select, message } from "antd";
import {
  activateUCaasAndSMS,
  deactivateUcaaSAndSMS,
  deactivateUser,
  transferUserLicense,
} from "../utils/LicenseManipulation";
import { UserLicenseContext } from "../utils/types";

export const showTransferLicenseConfirm = (
  loginName: string,
  licenses: any[],
  userId: string,
  customerLicenseIdOld: number,
  customerLicenseIdNew: number,
  context: UserLicenseContext,
  autoMailEnabled: boolean
) => {
  const licenseDescriptions = licenses
    .map((license: any) => license.licenseDescription)
    .join(", ");
  Modal.confirm({
    title: `Do you wish to transfer ${loginName} to another license?`,
    content: (
      <div style={{ lineHeight: "1.5", fontSize: "14px" }}>
        <p>
          <strong>User detected on: </strong> <b>{licenseDescriptions}</b>{" "}
          <strong> license</strong>.
        </p>
        <p>
          This user currently has a license active on {licenseDescriptions}, do
          you wish to transfer to the current one?
        </p>
      </div>
    ),
    okText: "Transfer",
    okType: "danger",
    maskClosable: true,
    cancelText: "Cancel",
    width: 600,
    cancelButtonProps: { id: "cancelButton" },
    onOk() {
      return transferUserLicense(
        Number(userId),
        customerLicenseIdNew,
        customerLicenseIdOld,
        context,
        autoMailEnabled
      );
    },
    onCancel() {},
  });
};

export const showExceededLicenseModal = () => {
  Modal.confirm({
    title: (
      <div>
        <span>
          <strong>Warning:</strong> License Limit Reached
        </span>
      </div>
    ),
    content: (
      <div>
        <p>You have reached the maximum number of users for this license.</p>
        <p>
          To enhance your experience and continue enjoying our services, please
          contact our support team to purchase additional licenses.
        </p>
        <p style={{ fontWeight: "bold", color: "#ff4d4f" }}>Contact Support:</p>
        <p style={{ fontWeight: "bold", color: "#ff4d4f" }}>
          Email:{" "}
          <a href="mailto:sales@wiline.com" style={{ color: "#00266c" }}>
            sales@wiline.com
          </a>
        </p>
        <p style={{ fontWeight: "bold", color: "#ff4d4f" }}>
          Phone:{" "}
          <a href="tel:+18884945463" style={{ color: "#00266c" }}>
            1-888-494-5463
          </a>
        </p>
        <p style={{ fontStyle: "italic", color: "#00266c" }}>
          We are here to help you 24/7!
        </p>
      </div>
    ),
    okText: "Buy Full",
    okButtonProps: { style: { display: "none" } },
    cancelText: "Cancel",
    maskClosable: true,
    width: 600,
    onOk() {
      console.log("OK");
    },
    onCancel() {
      console.log("Cancel");
    },
  });
};

export const showUCaaSAndSMSDisableConfirm = (
  loginName: string,
  userId: string,
  userLicenseId: number,
  context: UserLicenseContext
) => {
  const { setLoading } = context;
  Modal.confirm({
    title: `Do you wish to disable UCaaS and SMS for ${loginName}?`,
    content: (
      <div>
        <p>
          This action will disable both UCaaS and SMS for the selected user.
        </p>
      </div>
    ),
    okText: "Disable",
    okType: "danger",
    maskClosable: true,
    cancelText: "Cancel",
    width: 600,
    onOk() {
      return deactivateUcaaSAndSMS(userLicenseId, userId, context);
    },
    onCancel() {
      if (setLoading) setLoading(false);
    },
  });
};

export const showLicenseDowngradeConfirm = (
  loginName: string,
  licenseId: number,
  userId: string,
  userLicenseId: number,
  licenseTypes: any[],
  context: UserLicenseContext,
  autoMailEnabled: boolean
) => {
  const { setUserLicenses, updateTotalValue, form, AuthTokens } = context;
  const ucaasLicenses = licenseTypes.filter(
    (license) =>
      license.description.includes("UCaaS") &&
      !license.description.includes("SMS")
  );
  const licenseString = ucaasLicenses
    .map((license) => license.description)
    .join(" or ");
  Modal.confirm({
    title: `Do you wish to downgrade ${loginName}'s license to ${licenseString}?`,
    content: (
      <Form
        form={form}
        layout="vertical"
        style={{ lineHeight: "1.5", fontSize: "14px" }}
      >
        <p>
          <strong>Downgrade licenses detected:</strong> <b>{licenseString}</b>.
        </p>
        <Form.Item
          name="selectedLicense"
          label="Select UCaaS License to downgrade to:"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          rules={[
            { required: true, message: "Please select a UCaaS License!" },
          ]}
        >
          <Select style={{ width: "100%" }} placeholder="Select UCaaS License">
            {ucaasLicenses.map((license) => (
              <Select.Option key={license.key} value={license.key}>
                {license.description}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <p>
          If you do not wish to downgrade the user, press the <b>Cancel</b>{" "}
          button to only remove them from the current license.
        </p>
      </Form>
    ),
    okText: "Downgrade",
    okType: "danger",
    maskClosable: true,
    cancelText: "Cancel",
    width: 600,
    onOk() {
      return form!
        .validateFields()
        .then((values) => {
          return transferUserLicense(
            Number(userId),
            values.selectedLicense,
            licenseId,
            context,
            autoMailEnabled
          );
        })
        .catch((info) => {
          message.error("Please select a UCaaS License to downgrade to", 3);
        });
    },
    onCancel() {
      return deactivateUser(
        userLicenseId,
        userId,
        setUserLicenses,
        updateTotalValue,
        AuthTokens
      );
    },
  });
};

export const showUCaaSAndSMSConfirm = (
  loginName: string,
  userId: string,
  context: UserLicenseContext,
  type: string
) => {
  const { setLoading } = context;
  Modal.confirm({
    title: `Do you wish to enable UCaaS and SMS for ${loginName}?`,
    content: (
      <div>
        <p>This action will enable both UCaaS and SMS for the selected user.</p>
      </div>
    ),
    okText: "Enable",
    okType: "primary",
    maskClosable: true,
    cancelText: "Cancel",
    width: 600,
    onOk() {
      return activateUCaasAndSMS(userId, context, type);
    },
    onCancel() {
      if (setLoading) setLoading(false);
    },
  });
};

export const showContactUsPage = (isTrial: boolean) => {
  Modal.confirm({
    title: "Contact Us",
    content: (
      <div>
        <p>
          {isTrial
            ? "If you wish to activate your trial license to a full license in order to enhance your experience and continue enjoying our services, please contact our support team."
            : "If you wish to get more licenses to enhance your experience and continue enjoying our services, please contact our support team to purchase additional licenses."}
        </p>
        <p style={{ fontWeight: "bold", color: "#ff4d4f" }}>Contact Support:</p>
        <p style={{ fontWeight: "bold", color: "#ff4d4f" }}>
          Email:{" "}
          <a href="mailto:sales@wiline.com" style={{ color: "#00266c" }}>
            sales@wiline.com
          </a>
        </p>
        <p style={{ fontWeight: "bold", color: "#ff4d4f" }}>
          Phone:{" "}
          <a href="tel:+18884945463" style={{ color: "#00266c" }}>
            1-888-494-5463
          </a>
        </p>
        <p style={{ fontStyle: "italic", color: "#00266c" }}>
          We are here to help you 24/7!
        </p>
      </div>
    ),
    okText: "Buy Full",
    okButtonProps: { style: { display: "none" } },
    cancelText: "Cancel",
    maskClosable: true,
    width: 600,
  });
};
